module.exports = __webpack_public_path__ + "static/media/friends-attending-promotion-class-calendar.5038e1b1.webp";